import { fetchApi } from '@/config/axiosSetting';

import {
  IGetInsurerInformationTabsAlertsParams,
  IGetInsurerInformationTabsAlertsResponse,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationTabsAlerts/getInsurerInformationTabsAlertsQuery.type';

export const getInsurerInformationTabsAlertsQueryFunctions = (
  params: IGetInsurerInformationTabsAlertsParams,
): Promise<IGetInsurerInformationTabsAlertsResponse> =>
  fetchApi.get(`body/reports/${params.id}/alerts/`);
